module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_7042.ed8f4f74.png";